import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
} from 'config/providers';
import { CoxTheme } from 'config/themes';

export const CoxCableSpecialGenericShop: SingleProviderConfig = {
  name: 'CoxCableSpecialGenericShop',
  micrositeCode: 'cox_generic_shop',
  mainProvider: Cox,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'coxcablespecial.com',
  homepage: 'https://shop.coxcablespecial.com/generic',
  title: 'Cox Authorized Dealer',
  fallbackPhoneNumber: '844-530-1889',
  fallbackLeadModePhoneNumber: '844-530-1888',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: CoxTheme,
  needsDcSession: false,
  source: 'Cox',
  noOffersRetry: 2,
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.coxcablespecial.com/guest/tvi/buy',
    qa: 'https://staging-cart.coxcablespecial.com/guest/tvi/buy',
    production: 'https://cart.coxcablespecial.com/guest/tvi/buy',
  },
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: asyncEligible,
  crossSellProviders: [
    Comcast,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
  ],
};
